import React from 'react'
import styled from 'styled-components'

export const VideoGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .video {
    width: calc(100% - 2rem);
    margin: 1rem auto;
  }

  .video p {
    margin-top: .5rem;
  }

  @media only screen and (min-width: 768px) {
    .video {
      width: calc(50% - 2rem);
    }
  }
`
